import { createFeature, createReducer, on } from '@ngrx/store';
import { MenuActions } from './menu.actions';
import { MenuKey } from '../../../enums/menu.enum';

export interface MenuState {
  activeLevel2: MenuKey | null;
}

const initialState: MenuState = {
  activeLevel2: null,
};

export const menuFeature = createFeature({
  name: 'menu',
  reducer: createReducer(
    initialState,
    on(MenuActions.resetToInitialState, () => ({ ...initialState })),
    on(MenuActions.setActiveLevel2Menu, (state, { activeLevel2 }) => ({
      ...state,
      activeLevel2,
    })),
  ),
});
